export default __webpack_public_path__ + "static/media/kitchen5-afterB-768w.a1a53587.avif";